<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout align-center justify-start wrap>
      <v-flex xs12 md4>
        <SelectCreditors
          :multiple="false"
          :selected="selectedCreditor"
          :negotiation="true"
          @selectedCreditors="changeSelectCreditors($event)"></SelectCreditors>
      </v-flex>

      <v-flex v-if="selectedCreditor" xs12 md12>
        <v-data-table
          :headers="headers"
          align-center
          justify-center
          :items="incentiveApproachList"
          :total-items="totalItems"
          :pagination.sync="pagination"
          no-data-text="Nenhuma abordagem para este credor"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
          hide-actions>
          <template slot="headerCell" slot-scope="props">
            <v-tooltip top dark :disabled="!props.header.tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ props.header.text }}
                  <v-icon class="ml-1" v-if="props.header.info" small>
                    mdi-information-outline
                  </v-icon>
                </span>
              </template>
              <span v-if="props.header.tooltip">{{ props.header.tooltip }}</span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="{ item }">
            <tr :style="`${item.active ? '' : 'opacity:.5;'}`">
              <td>{{ getCreditorInfo(item.creditor_id).name || "" }}</td>

              <td>
                <span :class="`small chip-incentive-step  ${item.incentive_step}`">{{
                  incentiveApproachUtils.step[item.incentive_step].name
                }}</span>
              </td>

              <td>
                <span :class="`tag-approach-type  ${item.approach_type}`">{{
                  incentiveApproachUtils.type[item.approach_type].name
                }}</span>
              </td>

              <td v-html="formatApproachScheduleTo(item.schedule_to)"></td>

              <td>
                <v-chip
                  :color="item.active ? 'green' : ''"
                  :text-color="item.active ? 'white' : 'black'"
                  class="py-0 my-0"
                  small>
                  <span v-if="item.active">Ativo</span>
                  <span v-else>Inativo</span>
                </v-chip>
              </td>

              <td>
                <v-checkbox
                  readonly
                  hide-details
                  color="accent"
                  v-model="item.always_send"></v-checkbox>
              </td>

              <td>
                <span v-if="item.approach.messages.length" class="d-inline-flex align-center">
                  {{ item.approach.messages.length || 0 }}
                  {{ `${item.approach.messages.length > 1 ? "mensagens" : "mensagem"}` }}

                  <MessageInconsistencyAlert :inconsistencies="getInconsistencies(item.approach.messages)" />
                </span>
                <span v-else>--</span>
              </td>

              <td>{{ item.changed_by }} em
                </br> 
                <p>
                  {{ item.updated_at | formatDateTime }}
                </p>
              </td>

              <td class="text-xs-center pa-0">
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="editIncentiveApproaches(item)">
                      <v-list-tile-action>
                      <v-icon>mdi-message-text-outline</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Mensagens</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile @click="handleConfigDialog(item)">
                      <v-list-tile-action>
                      <v-icon>mdi-calendar-clock</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Agendamento</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile @click="updateStatus(item)">
                      <v-list-tile-action>
                        <v-icon>
                          {{ !item.active ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>
                      {{ !item.active ? "Ativar" : "Desativar" }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5)">
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"></v-progress-circular>
                <strong v-else class="py-2" style="font-size: 14px"
                  >Nenhum incentivo de abordagem encontrada</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex v-else xs12 md12 class="pa-5">
        <v-layout align-center justify-center wrap>
          <p class="title">Selecione um credor para visualizar as abordagens de incentivo.</p>
        </v-layout>
      </v-flex>
    </v-layout>

    <ConfigureIncentiveDialog
      @save="handleSaveConfig"
      @cancel="handleCloseConfigDialog"
      :configDialog="configDialog"
      :config="configDialogData" />
  </v-container>
</template>

<script>
import store from "@/store";
import { mapActions, mapGetters } from "vuex";
import approachType from "@/utils/approach-type";
import incentiveApproachUtils from "@/utils/incentive-approach";

import creditorService from "@/services/creditor";

import SelectCreditors from "@/components/creditor/SelectCreditors";
import MessageInconsistencyAlert from "@/components/ui/MessageInconsistencyAlert.vue";
import ConfigureIncentiveDialog from "./components/ConfigureIncentiveDialog.vue";

export default {
  components: {
    SelectCreditors,
    ConfigureIncentiveDialog,
    MessageInconsistencyAlert,
  },
  data() {
    return {
      incentiveApproachUtils,
      fab: false,
      configDialog: false,
      configDialogData: {},
      loading: false,
      doneFetching: false,
      totalItems: 0,
      selectedCreditor: 0,
      approachType: [],
      approachsTypes: [],
      query: {},
      creditors: {},
      pagination: {
        sortBy: "updated_at",
        rowsPerPage: 100,
      },
      headers: [
        {
          text: "Credor",
          align: "left",
          value: "creditor.name",
          width: "10%",
          sortable: false,
        },
        {
          text: "Etapa",
          align: "left",
          value: "incentive_step",
          width: "15%",
          sortable: false,
        },
        {
          text: "Canal",
          align: "left",
          value: "approach_type",
          width: "10%",
          sortable: false,
        },
        {
          text: "Agendamento",
          align: "left",
          value: "schedule_to",
          width: "10%",
          sortable: false,
        },
        {
          text: "Status",
          align: "left",
          value: "active",
          width: "10%",
        },
        {
          text: "Sempre Enviar",
          align: "left",
          value: "always_send",
          tooltip:
            "Por padrão o incentivo só será enviado para o canal originario do acesso. Caso selecionado,  sempre será enviado independente do canal de origem de acesso.",
          width: "10%",
          sortable: false,
          info: true,
        },
        {
          text: "Tamanho",
          align: "left",
          value: "notify_type",
          width: "10%",
        },
        {
          text: "Atualização",
          align: "left",
          value: "updated_at",
          width: "10%",
        },
        {
          text: "",
          align: "center",
          value: "",
          sortable: false,
          width: "2%",
        },
      ],
    };
  },
  async created() {
    await this.getCreditors();

    this.approachType = approachType.approachType;
    this.approachsTypes = approachType.approachType.map((e) => e.value);

    this.query = this.$route.query;

    if (this.query && Object.keys(this.query).length == 0) {
      this.query = store.getters.getManualStrategy;
    }

    if (this.query) {
      if (this.query.sortBy) this.pagination.sortBy = this.query.sortBy;

      if (this.query.creditor) {
        this.selectedCreditor = parseInt(this.query.creditor);
        this.query.creditor = this.selectedCreditor;
      }
    }
    if (this.selectedCreditor) {
      await this.searchIncentiveApproach();
    }

    this.doneFetching = true;
  },
  computed: {
    ...mapGetters("incentiveApproach", ["incentiveApproachList"]),
  },
  watch: {
    pagination: {
      async handler() {
        if (this.doneFetching) {
          this.addfilters();

          await this.searchIncentiveApproach();
        }
      },
      deep: true,
    },
    selectedCreditor: {
      async handler() {
        if (this.doneFetching) {
          this.addfilters();
          await this.searchIncentiveApproach();
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("incentiveApproach", [
      "getAllIncentiveApproaches",
      "activateOrDeactivateIncentiveApproach",
      "editIncentiveApproach",
    ]),

    handleConfigDialog(item) {
      this.configDialogData = item;
      this.configDialog = true;
    },

    handleCloseConfigDialog() {
      this.configDialogData = {};
      this.configDialog = false;
    },

    changeSelectCreditors(event) {
      this.selectedCreditor = event;
      this.searchIncentiveApproach();
    },

    getCreditorInfo(creditor_id) {
      if (!creditor_id || !this.creditors) return null;
      return this.creditors.objects.find((c) => c.creditor_id === creditor_id) || null;
    },

    formatApproachScheduleTo(schedule_to) {
      const today = schedule_to.includes("in");
      const isHour = schedule_to.includes("hour");
      const timeMeasure = today ? (isHour ? "hora" : "minuto") : "";
      const parts = schedule_to.split(" ");
      const timeValue = today ? Number(parts[1]) : parts[2];

      if (today) {
        if (timeValue === 0) {
          return "<b>Imediatamente</b>";
        }

        const measure = timeValue === 1 ? timeMeasure : `${timeMeasure}s`;

        return `Após <b>${timeValue} ${measure}</b>`;
      } else {
        return `Amanhã às <b>${timeValue}</b>`;
      }
    },

    async searchIncentiveApproach() {
      this.addfilters();

      if (this.loading) return;
      this.loading = true;

      try {
        await this.getAllIncentiveApproaches({
          creditor_id: this.selectedCreditor,
          pagination: { ...this.pagination },
        });

        this.totalItems = this.incentiveApproachList.length;
      } catch (err) {
        this.$store.commit("showSnackbar", "Houve um erro ao buscar os dados");
      } finally {
        this.loading = false;
      }
    },

    addfilters() {
      this.query = {};

      if (this.pagination.sortBy) this.query.sortBy = this.pagination.sortBy;
      else this.query.sortBy = 0;

      if (this.selectedCreditor > 0) this.query.creditor = this.selectedCreditor;

      if (this.$route.path == "/incentive-approach") {
        this.$router.replace({
          name: "Abordagens de Incentivo",
          query: this.query,
        });
      }
    },

    editIncentiveApproaches(incentive) {
      this.$router.push({
        path: `/incentive-approach/${incentive.id}`,
      });
    },

    configureApproach(approach) {
      this.$router.push({
        name: "Abordagens de Incentivo",
        params: {
          edit: true,
          approach_id: approach.id,
        },
      });
    },

    getInconsistencies(messages) {
      if (!messages || !messages.length) return [];
      const uniqueSet = new Set();
      messages.forEach((message) => {
        if (message.message_inconsistencies) {
          message.message_inconsistencies.forEach((inconsistency) => uniqueSet.add(inconsistency));
        }
      });
      return Array.from(uniqueSet);
    },

    async updateStatus(incentiveApproach) {
      try {
        await this.activateOrDeactivateIncentiveApproach(incentiveApproach);

        const message = incentiveApproach.active ? `Incentivo desativado!` : `Incentivo ativado!`;

        this.$store.commit("showSnackbar", {
          message,
          important: true,
        });

        await this.searchIncentiveApproach();
      } catch (err) {
        this.$store.commit("showSnackbar", "Houve um erro ao salvar");
        console.error("Houve um erro", err);
      }
    },

    formatApproach(item) {
      let messages = item.messages || [];
      let messagesLength = messages.length;

      return messagesLength <= 1 ? messagesLength + " mensagem" : messagesLength + " mensagens";
    },

    isWhatsappApproach(item) {
      const approachType = String((item && item.approach_type) || "").toUpperCase();
      return approachType.includes("WHATSAPP");
    },

    async getCreditors() {
      await creditorService
        .list()
        .then((res) => {
          this.creditors = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async handleSaveConfig(payload) {
      await this.editIncentiveApproach(payload);
      this.handleCloseConfigDialog();
      await this.searchIncentiveApproach();
    },
  },
};
</script>

<style>
.v-datatable__actions__range-controls {
  margin-right: 8%;
}

.chip-incentive-step {
  padding: 6px 4px;
  color: white;
  margin-right: 2px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
}
</style>
